document.addEventListener('DOMContentLoaded', function() {
    const IS_OPEN_CLASS = 'is-SharePopup-open';
    const QR_ACTIVE_CLASS = 'is-active';
    const FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const el = {
        openBtn: document.querySelector('[data-share-popup-open]'),
        closeBtns: document.querySelectorAll('[data-share-popup-close]'),
        body: document.body,
        popup: document.querySelector('.SharePopup'),
        urlInput: document.querySelector('[data-share-url]'),
        copyBtn: document.querySelector('[data-share-copy]'),
        copyTooltip: document.querySelector('[data-share-copy-tooltip]'),
        qrToggle: document.querySelector('[data-share-qr-toggle]'),
        qrContainer: document.querySelector('[data-share-qr-container]')
    };

    if (!el.openBtn || !el.popup) return;

    let lastFocusedEl = null;
    let tooltipClearTimer = null;

    const setQrVisible = (visible) => {
        if (!el.qrContainer) return;
        el.qrContainer.classList.toggle(QR_ACTIVE_CLASS, visible);
        if (el.qrToggle) el.qrToggle.setAttribute('aria-expanded', String(visible));
    };

    const hideCopiedTooltip = () => {
        if (!el.copyTooltip) return;
        el.copyTooltip.classList.remove('is-visible');
        // Text vyčistíme až po doznění fade-outu, aby zmizel plynule (ne skokově)
        clearTimeout(tooltipClearTimer);
        tooltipClearTimer = setTimeout(() => { el.copyTooltip.textContent = ''; }, 300);
    };

    const openPopup = () => {
        lastFocusedEl = document.activeElement;
        const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
        if (scrollBarWidth > 0) el.body.style.paddingRight = `${scrollBarWidth}px`;
        el.body.classList.add(IS_OPEN_CLASS);
        el.popup.focus(); // Přesun focusu do popupu (přístupnost)
    };

    const closePopup = () => {
        el.body.classList.remove(IS_OPEN_CLASS);
        el.body.style.paddingRight = '';
        setQrVisible(false); // Reset QR, aby při dalším otevření nezůstal viditelný
        hideCopiedTooltip();
        if (lastFocusedEl) lastFocusedEl.focus(); // Vrácení focusu na spouštěcí prvek
    };

    el.openBtn.addEventListener('click', openPopup);

    el.closeBtns.forEach(btn => btn.addEventListener('click', closePopup));

    document.addEventListener('keydown', (e) => {
        if (!el.body.classList.contains(IS_OPEN_CLASS)) return;

        if (e.key === 'Escape') {
            closePopup();
            return;
        }

        if (e.key === 'Tab') { // Udržení focusu uvnitř popupu (focus trap)
            const focusable = Array.from(el.popup.querySelectorAll(FOCUSABLE_SELECTOR))
                .filter(node => node.offsetParent !== null);
            if (!focusable.length) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];

            if (e.shiftKey && (document.activeElement === first || document.activeElement === el.popup)) {
                e.preventDefault();
                last.focus();
            } else if (!e.shiftKey && document.activeElement === last) {
                e.preventDefault();
                first.focus();
            }
        }
    });

    if (el.urlInput) {
        // Prosté kliknutí označí celý odkaz; tažením myší lze vybrat jen jeho část.
        el.urlInput.addEventListener('mouseup', () => {
            // Po tažení je výběr neprázdný – ten ponecháme. U prostého kliknutí
            // (prázdný/sbalený výběr) označíme celý odkaz.
            if (el.urlInput.selectionStart === el.urlInput.selectionEnd) {
                el.urlInput.select();
                el.urlInput.setSelectionRange(0, 99999);
            }
        });
    }

    if (el.copyBtn && el.urlInput) {
        let hideTimer = null;

        const copyUrl = () => {
            el.urlInput.focus();
            el.urlInput.select(); // Odkaz se automaticky označí
            el.urlInput.setSelectionRange(0, 99999); // Kompatibilita se staršími mobilními prohlížeči

            // navigator.clipboard je dostupný jen v zabezpečeném kontextu (https); jinak fallback na execCommand (např. http dev)
            if (navigator.clipboard && window.isSecureContext) {
                return navigator.clipboard.writeText(el.urlInput.value);
            }
            return new Promise((resolve, reject) => {
                try {
                    document.execCommand('copy') ? resolve() : reject(new Error('execCommand copy selhal'));
                } catch (err) {
                    reject(err);
                }
            });
        };

        const showCopiedTooltip = () => {
            if (!el.copyTooltip) return;
            clearTimeout(tooltipClearTimer);
            el.copyTooltip.textContent = el.copyTooltip.dataset.message || ''; // Mutace obsahu kvůli oznámení čtečkám (aria-live)
            el.copyTooltip.classList.add('is-visible');
            clearTimeout(hideTimer);
            hideTimer = setTimeout(hideCopiedTooltip, 2000);
        };

        el.copyBtn.addEventListener('click', () => {
            copyUrl()
                .then(showCopiedTooltip)
                .catch(err => console.error('Nepodařilo se zkopírovat: ', err));
        });
    }

    if (el.qrToggle && el.qrContainer) {
        el.qrToggle.addEventListener('click', () => {
            setQrVisible(!el.qrContainer.classList.contains(QR_ACTIVE_CLASS));
        });
    }
});
